import EmailOutbox from "@/modules/emailOutbox/views/EmailOutbox.vue";

export const EmailOutboxRoutes = [
    {
        name: 'emailOutbox',
        path: '/outbox/email',
        component: EmailOutbox,
    }
];
